/// Set @keydown="handleKeyDown($event)" in html tag
/// Change p to section

import NewspaperModel from '../models/newspaper.model'
import { removeAllInlineStyle, removeHtml } from '../utils/helper'

export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 0
    },
    textHorizontal: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isSummary: {
      type: Boolean,
      default: false
    },
    isContent: {
      type: Boolean,
      default: false
    },
    characterAColumn: {
      type: Number,
      default: 14
    },
    isHtml: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isHidePlaceholder: false,
      tmpText: '',
      isEnter: false
    }
  },

  created () {
    if (this.fieldName) {
      this.isHidePlaceholder = !!this.item[this.fieldName].length && this.item[this.fieldName].trim() !== '<br>'
    }

    this.tmpText = this.item[this.fieldName] || '<br>'

    this.count = this.item[this.fieldName] ? removeHtml(this.item[this.fieldName]).length : 0
  },

  computed: {
    item () {
      return NewspaperModel.query().find(1) || new NewspaperModel()
    },

    /**
     * check which browser allow
     * @return {boolean}
     */
    isAllowBrowser () {
      const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)

      // Safari 3.0+ "[object HTMLElementConstructor]"
      let safari
      const isSafari = /constructor/i.test(window.HTMLElement) ||
        (function (p) { return p.toString() === '[object SafariRemoteNotification]' })(
          !window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))

      return !(!isChrome && !isSafari)
    }
  },

  methods: {
    /**
     * update state when typing
     * @param e
     */
    updateState (e) {
      const element = e.target

      this.isHidePlaceholder = !!element.textContent.length || element.innerHTML.trim() === '<br>'
      this.count = element.textContent.length

      //remove css inline
      if (element.hasChildNodes() && e.inputType ===
        'insertFromPaste') element.innerHTML = element.textContent

      this.item[this.fieldName] = this.isHtml ? element.innerHTML : removeHtml(element.textContent)

      // remove html when hit Enter for one column
      if (!e.data && this.isEnter && !this.isHtml) {
        e.target.innerHTML = this.tmpText = removeHtml(element.textContent)
      }
    },

    /**
     * handle Key press
     */
    handleKeyDown (e) {
      //set key
      this.isEnter = e.keyCode === 13

      // Enter Key
      if (e.keyCode === 13 || (e.code === 'Enter' && e.isComposing)) {
        this.submitText(e)

        return
      }

      // define KeyCode
      const keyArray = [37, 38, 39, 40]

      // if not in KeyCode will return
      if (!keyArray.includes(e.keyCode) || this.textHorizontal || this.isMobile) {
        return
      }

      e.preventDefault()

      switch (e.keyCode) {
        // left
        case 37:
          this.moveCaret(this.characterAColumn)
          break

        // up
        case 38:
          this.moveCaret(-1)
          break

        // right
        case 39:
          this.moveCaret(-this.characterAColumn)
          break

        // down
        case 40:
          this.moveCaret(1)
          break

        // default
        default:
          break
      }
    },

    /**
     * action call moving caret
     */
    moveCaret (charCount) {
      let selector

      if (window.getSelection) {

        selector = window.getSelection()
        if (selector.rangeCount > 0) {
          const textNode = selector.focusNode
          let newOffset = selector.focusOffset + charCount < 0 ? -1 : selector.focusOffset + charCount

          // return if no Node
          if (!textNode) {
            return
          }

          // if First NODE
          if (!textNode.previousSibling &&
            textNode.parentNode.nodeName === 'SECTION' &&
            newOffset < 0) {
            return
          }

          // previous
          if (newOffset < 0) {
            return this.movetoNode(selector, textNode, 'previousSibling')
          }

          // next
          if ((textNode.length < newOffset) ||
            ((textNode.nodeName === 'BR' || textNode.nodeName === 'DIV') && charCount > 0)) {

            // check if lastNode
            if (!textNode.isSameNode(textNode.parentNode.lastChild)) {
              return this.movetoNode(selector, textNode, 'nextSibling')
            }
          }

          //moving
          return selector.collapse(textNode, Math.min(textNode.length, newOffset))
        }
      }
    },

    /**
     * Action Next Or Prev Caret
     */
    movetoNode (selector, getNode, direction = 'nextSibling') {
      // NEXT CASE
      const SiblingNode = getNode.parentNode[direction]
        ? getNode.parentNode[direction]
        : getNode[direction]

      // LAST NODE
      if (!SiblingNode) {
        return this.setRangeAndMoveNode(selector, getNode, 'prev')
      }

      let newNode = SiblingNode.hasChildNodes()
        ? SiblingNode.childNodes[0]
        : SiblingNode

      // CASE WITH SECTION TAG
      if (getNode.parentNode.nodeName === 'SECTION') {
        newNode = getNode[direction].hasChildNodes()
          ? getNode[direction].childNodes[0]
          : getNode[direction]
      }

      return this.setRangeAndMoveNode(selector, newNode, direction === 'nextSibling' ? 'next' : 'prev')
    },

    /**
     * set new range to move caret
     * @param selector
     * @param node
     * @param direction
     */
    setRangeAndMoveNode (selector, node, direction = 'next') {
      // remove all range
      selector.removeAllRanges()

      // setting new range
      let newRange = document.createRange()
      const startPoint = direction === 'next' ? 0 : node.length

      if (direction === 'next') {
        newRange.setStartBefore(node)
      } else if (direction === 'prev') {
        newRange.setStartAfter(node)
      }

      newRange.collapse(true)

      // add new range
      selector.addRange(newRange)
      return selector.collapse(node, startPoint)
    },

    /**
     * select text
     * @return {string|Range|Selection|*}
     */
    selectHTML () {
      try {
        if (window.ActiveXObject) {
          let RANGE = document.selection.createRange()
          return RANGE.htmlText
        }

        let SPAN = document.createElement('div'),
          w = getSelection().getRangeAt(0)

        SPAN.classList.add('num')

        w.surroundContents(SPAN)
        return SPAN.innerHTML
      } catch (e) {
        if (window.ActiveXObject) {
          return document.selection.createRange()
        } else {
          return getSelection()
        }
      }
    },

    /**
     * Rotate Number
     */
    rotateNumber () {
      this.selectHTML()
      let el = document.getElementById('main-content').childNodes[0]
      let range = document.createRange()
      let sel = window.getSelection()

      range.setStart(el, 0)
      range.collapse(true)

      sel.removeAllRanges()
      sel.addRange(range)

      el.focus()
    },

    /**
     * Action to Submit Text
     * @param e
     */
    submitText (e) {
      // keyCode = 229 for enter text
      if (e.code === 'Enter' && e.isComposing) {
        this.cutString(e)
      }

      // keyCode = 13 break line
      else if (e.keyCode === 13) {
        const isOverLimitWidth = e.target.scrollWidth > e.target.clientWidth

        if (isOverLimitWidth) {
          e.target.blur()
          e.target.innerHTML = this.tmpText = this.item[this.fieldName]
        }
      }
    },

    /**
     * cut the string
     * @param e
     */
    cutString (e) {
      const plainText = removeHtml(this.item[this.fieldName])
      const text = plainText.substr(0, this.maxLength)

      if (this.count > this.maxLength) {
        setTimeout(() => {
          this.count = text.length

          e.target.blur()
          e.target.innerHTML = this.tmpText = text
        }, 300)
      }
    }
  }
}
